export enum CheckEntityType {
Checkbook,
SupplierCustomer,
Bank,
}
